/* eslint-disable max-len */
export const chartsColors = {
  CENTRO_SUR: "rgb(252, 179, 146)",
  CHIHUAHUA: "rgb(252, 206, 143)",
  CUAUHTEMOC: "rgb(160, 194, 225)",
  DELICIAS: "rgb(213, 240, 116)",
  PARRAL: "rgb(112, 220, 146)",
  "Zona centro sur": "rgb(252, 179, 146)",
  "Chihuahua": "rgb(252, 206, 143)",
  "Cuauhtémoc": "rgb(160, 194, 225)",
  "Delicias": "rgb(213, 240, 116)",
  "Parral": "rgb(112, 220, 146)",
  PUBLIC_POLICIES: "rgb(123, 197, 251)",
  INSTITUTIONAL_IMPROVEMENT: "rgb(147, 174, 251)",
  VIOLENCE_PREVENTION: "rgb(186, 142, 234)",
  RULE_OF_LAW: "rgb(251, 147, 197)",
  COMPETITIVENESS: "rgb(251, 147, 240)",
  INSTITUTIONAL_IMPROVEMENT_SECURITY_AND_JUSTICE: "rgb(251, 228, 147)", EVALUATE_MEASURE_AND_MONITOR_GOVERNMENT_ACTION_IN_SECURITY_AND_JUSTICE: "rgb(251, 184, 147)",
  CITIZEN_CORRESPONSIBILITY_AGAINST_CRIME: "rgb(174, 232, 204)",
  COMPETITIVENESS_PROMOTION: "rgb(103, 133, 168)"
}